import React from 'react';

export default function LoadingSpinner({ fullPage = false, text = 'Loading...' }) {
  if (fullPage) {
    return (
      <div className="page-loader">
        <div className="spinner-border text-primary" role="status" style={{ width: 40, height: 40 }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div style={{ fontSize: 14, color: '#6c757d' }}>{text}</div>
      </div>
    );
  }
  return (
    <div className="d-flex align-items-center justify-content-center py-4 gap-2">
      <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
      <span className="text-muted" style={{ fontSize: 13 }}>{text}</span>
    </div>
  );
}
